import React, {useEffect, useState} from 'react';
import characters from "../../assets/img/backgrounds/assessment/startCharacters.png";
import {Button, Col, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import {getDb} from "../../util/Constants";

const Start = ({userData, setUserData, metadata}) => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const isProgress = metadata?.environment === "progress";
    const db = getDb();

    useEffect(() => {
        setUserData({});
    }, []);

    const generateEventId = async () => {
        setLoading(true)

        // const _eventId = Math.floor(1000 + Math.random() * 9000).toString();
        // const docRef = doc(db, "event", _eventId);
        // console.log(_eventId);
        // const docSnap = await getDoc(docRef);
        // if (docSnap.exists()) {
        //     console.log("Event Id exists");
        //     await generateEventId();
        // } else {
        //     setUserData({...userData, eventData: {eventId: _eventId}});
        setTimeout(() => {
            setLoading(false);
            history.push("/assessment/info");
        }, 1000)
        // }

    }
    return (
        <div className="">
            {/*<div className="d-flex new-bg start-nav">*/}
            {/*    <NavbarBrand className="start-container">*/}
            {/*        <img src={logo} alt=""/>*/}
            {/*    </NavbarBrand>*/}
            {/*    <div>links</div>*/}
            {/*</div>*/}
            <div className="start-page-content">
                <Row>
                    <Col className="m-auto" lg={6} sm={12}>
                        <h1>Build and release your own engaging {isProgress ? "Learning" : "assessments"} solutions</h1>
                        {isProgress ?
                            <p>Build and release your own engaging Learning solutions
                                Effortlessly evaluate individuals & help them Learn, regardless of their location or
                                schedule, using any of our versatile Learning game. Just using simple stages, our
                                learning platform offers extensive customization options and is specifically designed to
                                captivate candidates.</p> :
                            <p>Effortlessly evaluate individuals, regardless of their location or schedule, using any of
                                our
                                versatile tests. Just using 4 simple stages, our assessment platform offers extensive
                                customization options and is specifically designed to captivate candidates.</p>
                        }
                        <div className="text-center text-lg-left">
                            <Button className="begin-button" color="" onClick={generateEventId}>
                                {loading ? <span className="text-white font-weight-normal">Please wait..</span> :
                                    <span className="text-white font-weight-normal">Lets begin!</span>}
                            </Button>
                            {/*<div className="mt-4 d-flex align-items-center">*/}
                            {/*    <span className="fs-14 font-weight-600">Already have an account?</span>*/}
                            {/*    <Button className="add-test-button fs-14 text-dark ml-2" size="sm" color=""> Sign*/}
                            {/*        Up</Button>*/}
                            {/*</div>*/}
                        </div>
                    </Col>
                    <Col className="text-center d-none d-lg-inline">
                        <img src={characters}/>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default Start;